const getLocalStorageItem = (key: string) => localStorage.getItem(key);

export default getLocalStorageItem;
